var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3OutdoorHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 23.61V61H38v-4h28V25.79L41.28 9.87 16 25.8V38h-4V23.59L41.3 5.12 70 23.61zM21.5 46.9a7 7 0 1014 0c0-4.72-5.69-9.56-7-15-1.31 5.44-7 10.28-7 15zm-15 17a7 7 0 1014 0c0-4.72-5.69-9.56-7-15-1.31 5.44-7 10.28-7 15z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Outdoor_humidity.475e17cf.svg";
export { SvgB3OutdoorHumidity as ReactComponent };